import React from "react";
import { type FreefieldInputProps } from "../models";
import { RadioGroup } from "components/Atoms/inputs/RadioGroup";

const FreefieldBooleanNullable = (props: FreefieldInputProps) => {
  let initialValue: string;

  if (props.initialValue === "true") initialValue = "true";
  else if (props.initialValue === "false") initialValue = "false";
  else initialValue = "";

  const [selected, setSelected] = React.useState<string>(initialValue);

  const onChange = (value: string) => {
    setSelected(value);
    props.onChange(value);
  };

  return <RadioGroup
    orientation="horizontal"
    options={[
      { label: RESX.GeneralLabels.lblYes, value: "true" },
      { label: RESX.GeneralLabels.lblNo, value: "false" },
      { label: RESX.GeneralLabels.NoChoiceMade, value: "" }
    ]}
    value={selected}
    onChange={onChange}
  />;
};

export default FreefieldBooleanNullable;